import { createStyles, makeStyles } from "@mui/styles";
import { CommonFonts, Colors } from "@/theme";

const useStyles = makeStyles((theme) =>
  createStyles({
    currencyInput: {
      ...CommonFonts.darkFont16,
      width: 60,
      textAlign: "center",
      fontFamily: "Montserrat",
      backgroundColor: "transparent",
      padding: "2px 0px",
      border: `1px solid transparent`,
      borderRadius: 2,
      transition: "border-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      outline: "none",
      "&:hover": {
        border: `1px solid ${Colors.GRAY_BORDER}`,
      },
      "&:focus": {
        border: `1px solid ${Colors.BLUE}`,
        transition: "border-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        PointerEvent: "none",
      },
      "&:focus:hover": {
        border: `1px solid ${Colors.BLUE}`,
        transition: "border-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        PointerEvent: "none",
      },
    },
    addButton: {
      width: 70,
      height: 35,
      "&.MuiButton-root": {
        fontSize: 10,
        fontWeight: "bold",
        textTransform: "none",
        borderRadius: 6,
      },
    },
  })
);

export default useStyles;
